import { createContext } from 'react';

export type CompareFeatureContextType = {
  compareData: Array<string>;
  isSelectedToCompare: (compareData: Array<string> | undefined, itemId: string) => boolean;
  handleCompare: (itemId: string, val: boolean) => void;
  handleRedirectCompare: () => void;
};

const CompareFeatureContext = createContext<CompareFeatureContextType | undefined>(undefined);

export default CompareFeatureContext;
